import { combineReducers } from 'redux';

import { UPDATE_CONTENT } from '../actions/content';
import { UPDATE_SEARCH_CRITERIA } from '../actions/search';

const q = (state = '', { type, payload }) => {
    let nextState = state;

    if (
        type === UPDATE_CONTENT &&
        payload &&
        payload.searchCriterias.eventSearch.q
    ) {
        nextState = payload.searchCriterias.eventSearch.q;
    }

    if (type === UPDATE_SEARCH_CRITERIA) {
        if (payload.eventSearch.q) {
            nextState = payload.eventSearch.q;
        } else {
            nextState = '';
        }
    }

    return nextState;
};

const dateRange = (state = {}, { type, payload }) => {
    let nextState = state;

    if (
        type === UPDATE_CONTENT &&
        payload &&
        payload.searchCriterias.eventSearch.dateRange
    ) {
        nextState = payload.searchCriterias.eventSearch.dateRange;
    }

    if (type === UPDATE_SEARCH_CRITERIA) {
        if (payload.eventSearch.dateRange) {
            nextState = payload.eventSearch.dateRange;
        } else {
            nextState = {};
        }
    }

    return nextState;
};

const durationRange = (state = {}, { type, payload }) => {
    let nextState = state;

    if (
        type === UPDATE_CONTENT &&
        payload &&
        payload.searchCriterias.eventSearch.durationRange
    ) {
        nextState = payload.searchCriterias.eventSearch.durationRange;
    }

    if (type === UPDATE_SEARCH_CRITERIA && payload.eventSearch.durationRange) {
        nextState = payload.eventSearch.durationRange;
    }

    return nextState;
};

const dates = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload) {
        if (payload.searchCriterias.eventSearch.dates) {
            nextState = payload.searchCriterias.eventSearch.dates;
        } else {
            nextState = '';
        }
    }

    if (type === UPDATE_SEARCH_CRITERIA) {
        if (payload.eventSearch.dates) {
            nextState = payload.eventSearch.dates;
        } else {
            nextState = '';
        }
    }

    return nextState;
};

const organizationsOr = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload) {
        if (payload.searchCriterias.eventSearch.organizationsOr) {
            nextState = payload.searchCriterias.eventSearch.organizationsOr;
        } else {
            nextState = [];
        }
    }
    // optimistic update
    if (type === UPDATE_SEARCH_CRITERIA) {
        if (payload.eventSearch.organizationsOr) {
            nextState = payload.eventSearch.organizationsOr;
        } else {
            nextState = [];
        }
    }

    return nextState;
};

const hash = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload) {
        if (payload.searchCriterias.eventSearch.hash) {
            nextState = payload.searchCriterias.eventSearch.hash;
        } else {
            nextState = '';
        }
    }
    // optimistic update
    if (type === UPDATE_SEARCH_CRITERIA) {
        if (payload.eventSearch.hash) {
            nextState = payload.eventSearch.hash;
        } else {
            nextState = '';
        }
    }

    return nextState;
};

const dedup = (state = false) => state;

const places = (state = [], { type, payload }) => {
    let nextState = state;

    if (
        type === UPDATE_CONTENT &&
        payload &&
        payload.searchCriterias.eventSearch.places
    ) {
        nextState = payload.searchCriterias.eventSearch.places;
    }

    if (type === UPDATE_SEARCH_CRITERIA && payload.eventSearch.places) {
        nextState = payload.eventSearch.places;
    }

    return nextState;
};

const price = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload) {
        if ('price' in payload.searchCriterias.eventSearch) {
            nextState = payload.searchCriterias.eventSearch.price;
        } else {
            nextState = '';
        }
    }

    if (type === UPDATE_SEARCH_CRITERIA) {
        if ('price' in payload.eventSearch) {
            nextState = payload.eventSearch.price;
        } else {
            nextState = '';
        }
    }

    return nextState;
};

const tags = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload) {
        if (payload.searchCriterias.eventSearch.tags) {
            nextState = payload.searchCriterias.eventSearch.tags;
        } else {
            nextState = [];
        }
    }

    if (type === UPDATE_SEARCH_CRITERIA) {
        if (payload.eventSearch.tags) {
            nextState = payload.eventSearch.tags;
        } else {
            nextState = [];
        }
    }

    return nextState;
};

const currencies = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload) {
        if (payload.searchCriterias.eventSearch.currencies) {
            nextState = payload.searchCriterias.eventSearch.currencies;
        } else {
            nextState = [];
        }
    }

    if (type === UPDATE_SEARCH_CRITERIA) {
        if (payload.eventSearch.currencies) {
            nextState = payload.eventSearch.currencies;
        } else {
            nextState = [];
        }
    }

    return nextState;
};

const languages = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload) {
        if (payload.searchCriterias.eventSearch.languages) {
            nextState = payload.searchCriterias.eventSearch.languages;
        } else {
            nextState = [];
        }
    }

    if (type === UPDATE_SEARCH_CRITERIA) {
        if (payload.eventSearch.languages) {
            nextState = payload.eventSearch.languages;
        } else {
            nextState = [];
        }
    }

    return nextState;
};

const special = (state = [], { type, payload }) => {
    let nextState = state;

    if (type === UPDATE_CONTENT && payload) {
        if (payload.searchCriterias.eventSearch.special) {
            nextState = payload.searchCriterias.eventSearch.special;
        } else {
            nextState = [];
        }
    }

    if (type === UPDATE_SEARCH_CRITERIA) {
        if (payload.eventSearch.special) {
            nextState = payload.eventSearch.special;
        } else {
            nextState = [];
        }
    }

    return nextState;
};

const searchId = (state = '', { type, payload }) => {
    let nextState = state;

    if (
        type === UPDATE_CONTENT &&
        payload &&
        payload.searchCriterias.searchId
    ) {
        nextState = payload.searchCriterias.searchId;
    }

    return nextState;
};

const page = (state = 1, { type, payload }) => {
    let nextState = state;

    if (
        type === UPDATE_CONTENT &&
        payload &&
        payload.searchCriterias.eventSearch.page
    ) {
        nextState = payload.searchCriterias.eventSearch.page;
    }

    if (type === UPDATE_SEARCH_CRITERIA && payload.eventSearch.page) {
        nextState = payload.eventSearch.page;
    }

    return nextState;
};

const bbox = (state = '', { type, payload }) => {
    let nextState = state;

    if (
        type === UPDATE_CONTENT &&
        payload &&
        payload.searchCriterias.eventSearch.bbox
    ) {
        nextState = payload.searchCriterias.eventSearch.bbox;
    }

    if (type === UPDATE_SEARCH_CRITERIA && payload.eventSearch.bbox) {
        nextState = payload.eventSearch.bbox;
    }

    if (
        type === UPDATE_SEARCH_CRITERIA &&
        state !== '' &&
        !payload.eventSearch.bbox
    ) {
        // Reset bbox search param
        nextState = '';
    }

    return nextState;
};

/* Since we are using a custom page size, our reducer is
hydrated with the key as a value so need to declare. */
const pageSize = (state = '') => {
    const nextState = state;

    return nextState;
};

/* Temporary solution to allow for search results with
ticket fly only events returned. If reducer hydrated with
a value here, it should be maintained for the entire session
so no need to further update the state. */
const source = (state = []) => {
    const nextState = state;

    return nextState;
};

const aggs = (state = {}) => {
    const nextState = state;

    return nextState;
};

const onlineEventsOnly = (state = false, { type, payload }) => {
    let nextState = state;

    if (
        type === UPDATE_SEARCH_CRITERIA &&
        'onlineEventsOnly' in payload.eventSearch
    ) {
        nextState = payload.eventSearch.onlineEventsOnly;
    }

    return nextState;
};

const ids = (state = []) => {
    const nextState = state;

    return nextState;
};

const clientTimezone = (state = '') => {
    const nextState = state;

    return nextState;
};

const articleSearch = combineReducers({
    q,
    places,
    tags,
    ids,
});

const eventSearch = combineReducers({
    q,
    dates,
    dateRange,
    durationRange,
    organizationsOr,
    dedup,
    hash,
    places,
    price,
    tags,
    page,
    pageSize,
    bbox,
    source,
    aggs,
    onlineEventsOnly,
    languages,
    currencies,
    clientTimezone,
    special,
});

const profileSearch = combineReducers({
    q,
    places,
});

export default combineReducers({
    articleSearch,
    eventSearch,
    profileSearch,
    searchId,
});
